import React from 'react'

function Team() {
    return (
        <div style={{
            height: '80px', display: 'flex',
            flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', fontSize:'1rem'
        }}><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
           <p> Welcome to our e-commerce website! We are a team of dedicated professionals who are passionate about providing high-quality products and exceptional customer service. Our company was founded with the goal of making online shopping easy, convenient, and enjoyable for everyone. We believe that everyone deserves access to quality products at fair prices, and we work hard to source the best products from around the world.
At our e-commerce website, you'll find a wide selection of products ranging from clothing and accessories to electronics and home goods. We only work with trusted suppliers who share our commitment to quality and sustainability, so you can be confident that you're getting the best products available.</p>
<p>As a company, we value transparency, honesty, and customer satisfaction above all else. 
We believe that the key to building long-lasting relationships with our customers is through open communication, fair pricing, and exceptional service.

Our team is made up of experienced professionals who are dedicated to ensuring that your shopping experience is as smooth and hassle-free as possible. If you have any questions or concerns, we are always here to help. You can reach us by email, phone, or live chat, and we will do everything in our power to resolve any issues quickly and to your satisfaction.</p>

<p>Thank you for choosing our e-commerce website for your shopping needs.<br></br><br></br> We appreciate your business and look forward to serving you for years to come.</p>

        </div>
    )
}

export default Team
